<template>
    <div class="container"> 
    
        <div> 
    
    
            <div class="col-md-9">
        
                <div>
            
                    <div class="header">
                    </div>
                        <div>
                            <div class="col-md-3">{{ this.GetTraduzioneLabel('Generic','TKN_USERNAME',this.LinguaUtente) }}: *</div>
                            <div class="col-md-9">
                                <input type    = "text" 
                                       class   = "form-control"
                                       :placeholder = "this.GetTraduzioneLabel('VUEAppContentSchedaUtente','TKN_PLACEH_NOME_UTENTE',this.LinguaUtente)"
                                       v-model = "DatiProfilo.USERNAME"
                                />
                            </div>
                        </div>
                        <br>
                        <br>
                        <div>
                            <div class="col-md-3">{{ this.GetTraduzioneLabel('VUEAppContentSchedaUtente','TKN_SCHEDA_UTENTE_RAG_SOC',this.LinguaUtente) }}: *</div>
                            <div class="col-md-9">
                                <input type    = "text" 
                                       class   = "form-control"
                                       v-model = "DatiProfilo.RAGIONE_SOCIALE"
                                       :placeholder = "this.GetTraduzioneLabel('VUEAppContentSchedaUtente','TKN_PLACEH_RAG_SOCIALE',this.LinguaUtente)"
                                />
                            </div>
                        </div>
                        <br>
                        <br>
                        <div class="form-row">
                            <div class="col-md-3">{{ this.GetTraduzioneLabel('VUEAppContentSchedaUtente','TKN_SCHEDA_UTENTE_EMAIL',this.LinguaUtente) }}: </div>
                            <div class="col-md-9">
                                <input type    = "text" 
                                       class   = "form-control"
                                       v-model = "DatiProfilo.EMAIL"
                                       :placeholder = "this.GetTraduzioneLabel('VUEAppContentSchedaUtente','TKN_PLACEH_EMAIL',this.LinguaUtente)"
                                />
                            </div>
                        </div>
                        <br>
                        <br>                
                        <div class="form-row" v-if="RuoloUtente == 'A'">
                            <div class="col-md-3">{{ this.GetTraduzioneLabel('VUEAppContentSchedaUtente','TKN_SCHEDA_UTENTE_RUOLO',this.LinguaUtente) }}: *</div>
                            <div class="col-md-3">
                                <select class="form-control" v-model="DatiProfilo.ROLE">
                                    <option v-for="Ruolo in ObjRuoli" :Key="Ruolo.Id" :value="Ruolo.Id">{{Ruolo.Descrizione}}</option>
                                </select>
                            </div>
                        </div>
                        <br v-if="RuoloUtente == 'A'">
                        <br v-if="RuoloUtente == 'A'">                    
                        
                        <div class="form-row">
                            <br>
                            <div class="col-md-3">{{ this.GetTraduzioneLabel('Generic','TKN_IMMAGINE',this.LinguaUtente) }}</div>
                            <div class="col-md-9">                                                       
                                <div class="col-md-2">  
                                    <div href="javascript:;" v-if="DatiProfilo.IMMAGINE != ''">
                                        <img style="height:50px" :src="DatiProfilo.IMMAGINE">
                                    </div>
                                    <div v-else>
                                        <img style="height:50px" src="@/assets/images/avatar_default.jpg">
                                    </div>
                                </div>
                                <div class="col-md-3">    
                                    <label class="btn btn-info" type="button" style="cursor:pointer; margin-left:-10px"> 
                                      {{ this.GetTraduzioneLabel('VUEAppContentSchedaUtente','TKN_SCHEDA_UTENTE_CARICA_FOTO',this.LinguaUtente) }}            
                                         <input style="display:none;" type="file" id="inputImmagineUtente" @change="LoadImmagineFromFile(elemento)" accept="image/*">
                                     </label>
                                </div>
                            </div>
                        </div> 
                        
                        <div class="form-row">
                            <br>
                            <div class="col-md-3">
                                <span>* {{ this.GetTraduzioneLabel('VUEAppContentSchedaUtente','TKN_SCHEDA_UTENTE_CAMPI_OBBL',this.LinguaUtente) }}</span>
                            </div>
                            
                            <div class="col-md-7">
                                
                                <div class="input-group" style="float:right">
                                    <button v-bind:disabled="CheckDati" type="button" class="btn btn-success" @click="OnClickConferma" style="width:140%;margin-top:10px; float:right">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="input-group">
                                    <button type="button" class="btn btn-danger" @click="OnClickAnnulla" style="width:150%;margin-top:10px;">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
                                </div>
                            </div>
                        </div>  
                </div>    
            </div>       
        </div>
    </div>
    </template>
    
    
    
    
    
    <script>
    import { SystemInformation,RUOLI } from '@/SystemInformation.js'
    import MixInsGestioneTraduzioni from '@/utils/MixInsGestioneTraduzioni.js';
    import { TZImageFunct } from '@/utils/ZImageFunct.js'
    
    export default {
        name:'app',
        components: {
        },
        emits: ['OnClickConfermaModifiche'],
        mixins: [ MixInsGestioneTraduzioni ],
        data()
        {
           return {
                     DatiProfilo     : {},
                     Ruoli           : RUOLI,
                     Modello         : '',
                     ObjRuoli        : [],
                     LinguaUtente : SystemInformation.UserInformation.Lingua,
                     RuoloUtente     : SystemInformation.UserInformation.Ruolo,
                  }
        },
        methods :
        {
          OnClickAnnulla()
          {
            this.$router.push('/appMainWindow/GestioneUtenti')
          },
    
          OnClickConferma()
          {
            var ObjQuery = {Operazioni : []}
            var Self = this
            ObjQuery.Operazioni.push(
                            {
                            Query : this.$route.params.pagina == 'nuovo' ? 'Insert' : 'Update',
                            Parametri : {
                                            CHIAVE          : this.$route.params.pagina == 'nuovo' ? undefined : this.$route.params.pagina,
                                            USERNAME        : this.DatiProfilo.USERNAME,
                                            RAGIONE_SOCIALE : this.DatiProfilo.RAGIONE_SOCIALE,
                                            EMAIL           : this.DatiProfilo.EMAIL,
                                            IMMAGINE        : this.DatiProfilo.IMMAGINE,
                                            TELEFONO        : this.DatiProfilo.TELEFONO,  
                                            ROLE            : this.DatiProfilo.ROLE                          
                            }
                        })
            SystemInformation.AdvQuery.PostSQL(this.Modello, ObjQuery, function(){
                                                                                        Self.$emit('OnClickConfermaModifiche')
                                                                                        Self.$router.push(('/appMainWindow/GestioneUtenti'))
                                                                                    }, SystemInformation.HandleError)
          },
    
          EliminaLogo()     
          {
            var Self = this;
            Self.DatiProfilo.IMMAGINE = '';
          },
    
          LoadImmagineFromFile()
          {
            var Self    = this;
            var Reader  = new FileReader()
            var ImgFile = document.getElementById('inputImmagineUtente')
            
            var TypeImg = ImgFile.files[0].type
            Reader.readAsDataURL(ImgFile.files[0])
    
            Reader.onload = function (e) 
            {
               var Img = new Image()
               Img.onload = function () 
               {
                  Img.onload = undefined;
                  TZImageFunct.ResizeImage(Img,300,300,TypeImg) 
                  Self.DatiProfilo.IMMAGINE = Img.src 
               }
               Img.src = e.target.result
            }
           }
        },
    
        computed :
        {
          CheckDati()
          {
            if (this.DatiProfilo.USERNAME != '' &&
                this.DatiProfilo.ROLE != '' && 
                this.DatiProfilo.RAGIONE_SOCIALE != '')
                return false
            return true
          }
        },
        beforeMount()
        {
          if (this.RuoloUtente == 'A')
            this.ObjRuoli = [{Id: 'A', Descrizione: 'Amministratore CSG'},
                             {Id: 'M', Descrizione: 'Supervisore CSG'},
                             {Id: 'S', Descrizione: 'SuperUtente'}]
          switch (SystemInformation.UserInformation.Ruolo)
          {
            case this.Ruoli.Amministratore : this.Modello = 'Admin_GestioneUtenti'
            break
            case this.Ruoli.SuperUtente    : this.Modello = 'SuperUtente_GestioneUtenti'
            break
            default                        : this.Modello = ''
          }
          var Self = this;
          if (this.$route.params.pagina != 'nuovo')
          {
              SystemInformation.AdvQuery.GetSQL(this.Modello,{CHIAVE : this.$route.params.pagina},
              function(Results)
              {
                  let ArrayInfo = SystemInformation.AdvQuery.FindResults(Results,"Dettaglio")
                  if(ArrayInfo != undefined)
                  {
                      Self.DatiProfilo = ArrayInfo[0]
                  }
                  else SystemInformation.HandleError('Errore nel modello utenti')
              },
              SystemInformation.HandleError, 'SelectDettaglio');   
          }
          else this.DatiProfilo = {
                                      CHIAVE : undefined,
                                      IMMAGINE : '',
                                      RAGIONE_SOCIALE : '',
                                      ROLE : 'S',
                                      USERNAME : '',
                                      EMAIL : '',
                                      TELEFONO : '' 
                                  }
        },
        
    }
    </script>